import { SlicePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, DestroyRef, inject, input, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatIconModule } from '@angular/material/icon';
import { Connection } from '@modules/connections/types/connection';
import { KnowledgePanelService } from '@modules/knowledge/services/knowledge-panel.service';
import { IncludesByPipe } from '@modules/utils/pipes/array/includes-by.pipe';
import { ParticipantContextMenuDirective } from '../../directives/participant-context-menu.directive';
import { FormatParticipantPipe } from '../../pipes/format-participant.pipe';
import { type Participant } from '../../types/participant';

@Component({
  selector: 'app-contacts-inline-list',
  templateUrl: './contacts-inline-list.component.html',
  styleUrls: ['./contacts-inline-list.component.less'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SlicePipe, MatIconModule, IncludesByPipe, ParticipantContextMenuDirective, FormatParticipantPipe],
})
export class ContactsInlineListComponent {
  // Inputs
  public readonly contacts = input.required<Participant[]>();
  public readonly tenantItems = input<ReadonlyArray<{ readonly accountId?: string }> | undefined>();
  public readonly minLength = input<number>(2);
  public readonly label = input.required<string>();

  // Services
  private readonly kpService = inject(KnowledgePanelService);
  private readonly destroyRef = inject(DestroyRef);

  // State
  protected readonly selectedConnections = signal<Connection[]>([]);
  protected readonly collapsed = signal<boolean>(true);

  constructor() {
    // Subscribe to selected connections
    this.kpService
      .getSelectedConnections()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((connections: Connection[]) => {
        this.selectedConnections.set(connections);
      });
  }

  /**
   * Actions
   */

  protected selectContact(contact: Participant, event: MouseEvent): void {
    this.kpService.addConnectionToSelection(new Connection({ name: contact.address }), event, true);
  }

  protected toggleContacts(): void {
    this.collapsed.update((value) => !value);
  }
}
